import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0058',
    ecrans: ['00-2'],
    params:['doccleint', '?value']
});

